import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import {
  Hero,
  TopBar,
  LogoZion,
  HeroContent,
  HeroText,
  Eyebrow,
  Headline,
  Subtitle,
  StoreButtons,
  StoreButton,
  Disclaimer,
  MockupWrapper,
  Mockup,
} from './DownloadApp.style';

const APP_STORE_URL = 'https://apps.apple.com/br/app/zion-church-global/id6760800239';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.zion.global&pcampaignid=web_share';

const DownloadApp = ({ title }) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = title;
  }, []);

  return (
    <Hero>
      <TopBar>
        <LogoZion
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt='Zion'
          onClick={() => navigate('/', { replace: false })}
        />
      </TopBar>

      <HeroContent>
        <HeroText>
          <Eyebrow>{translate('Novo app')}</Eyebrow>
          <Headline>
            {translate('Já está disponível o')}
            <strong>{translate('novo app da Zion')}</strong>
          </Headline>
          <Subtitle>
            {translate(
              'Devocionais, eventos, grupos, check-in e conteúdos da Zion na palma da sua mão. Baixe agora o Zion Church Global e viva a igreja todos os dias.',
            )}
          </Subtitle>
          <StoreButtons>
            <StoreButton href={APP_STORE_URL} target='_blank' rel='noreferrer noopener'>
              <FaApple />
              <div className='store-label'>
                <small>{translate('Baixe na')}</small>
                <span>App Store</span>
              </div>
            </StoreButton>
            <StoreButton href={PLAY_STORE_URL} target='_blank' rel='noreferrer noopener'>
              <FaGooglePlay />
              <div className='store-label'>
                <small>{translate('Disponível no')}</small>
                <span>Google Play</span>
              </div>
            </StoreButton>
          </StoreButtons>
          <Disclaimer>{translate('Gratuito para iPhone e Android.')}</Disclaimer>
        </HeroText>

        <MockupWrapper>
          <Mockup
            src={`${process.env.PUBLIC_URL}/${encodeURIComponent('ZION GLOBAL PLATFORM.png')}`}
            alt={translate('App da Zion no celular')}
          />
        </MockupWrapper>
      </HeroContent>
    </Hero>
  );
};

export default DownloadApp;
